import { render, staticRenderFns } from "./DiskSideBarItem.vue?vue&type=template&id=b7861b54&scoped=true&"
import script from "./DiskSideBarItem.vue?vue&type=script&lang=js&"
export * from "./DiskSideBarItem.vue?vue&type=script&lang=js&"
import style0 from "./DiskSideBarItem.vue?vue&type=style&index=0&id=b7861b54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7861b54",
  null
  
)

export default component.exports